import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsButtonModule, CmpsDialogModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { ChartModule } from '../chart/chart.module';

import { PopulationGroupDialogComponent } from './population-group-dialog.component';
import { TranslationIdMap } from './population-group-dialog.i18n';

@NgModule({
    declarations: [PopulationGroupDialogComponent],
    exports: [PopulationGroupDialogComponent],
    imports: [
        CommonModule,
        ChartModule,
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
    ],
})
export class CmpsMi2PopulationGroupDialogModule {}
